import { OfflinePlayer } from './OfflinePlayer';
import { withRouter } from 'react-router-dom';

export default withRouter(OfflinePlayer);



// WEBPACK FOOTER //
// ./src/components/OfflinePlayer/index.js